import * as React from 'react';
import type { CalendarMonthDayCellModel } from '../../store/schema/CalendarMonthDayCellModel';
import type {
    CalendarSurfaceStore,
    SurfaceDecorator,
    SurfaceDecoratorProps,
} from 'owa-calendar-surface-dategrid';
import { getMonth } from 'owa-datetime';
import { observer } from 'mobx-react-lite';

let styles = require('owa-calendar-surface-dategrid/lib/logic/SelectionStyles.scss');
let classNames = require('classnames/bind').bind(styles);

export function createMonthDayCellsDecorator(
    store: CalendarSurfaceStore
): SurfaceDecorator<CalendarMonthDayCellModel> {
    return observer(({ item, ...divProps }: SurfaceDecoratorProps<CalendarMonthDayCellModel>) => {
        let isFocused = store.focusedSurfaceElement == item;
        let isCurrentMonth = item.month == getMonth(item.date);

        let itemClass = classNames(
            styles.dayCell,
            { itemFocused: isFocused },
            { dayCellCurrentMonth: isCurrentMonth }
        );
        return <div {...divProps} className={itemClass} />;
    });
}
